import { AddRoutesComponent } from "./add-routes/add-routes.component";
import { ViewRoutesComponent } from "./view-routes/view-routes.component";

export const RoutesDeclaration = [
    ViewRoutesComponent,
    AddRoutesComponent
]